<input
  class="form-control"
  (keydown.shift.enter)="createNewline($event)"
  [hidden]="isTextAreaActive"
  type="text"
  [ngModel]="elementInputValue"
  (input)="writeValue($event.target.value)" />

<textarea
  #txtarea
  class="form-control"
  [hidden]="!isTextAreaActive"
  [ngModel]="elementInputValue"
  (ngModelChange)="writeValue($event)"></textarea>
